import find from 'lodash/find';
import get from 'lodash/get';

import communicationQueuesResource from 'src/actions/communicationQueues/communicationQueuesResource';
import { getAgentDesktopURL } from 'src/presentation/components/pages/shared/utils/Utils';
import { PhoneNumberCapability } from 'src/models/CompanyPhoneNumber/CompanyPhoneNumber';
import routingGroupsResource from 'src/actions/routingGroups/routingGroupsResource';
import useConfigurationResource from './useConfigurationResourceByType';
import { useResourceValues } from 'src/presentation/hooks/useResource';

const useSelectInbox = (entityType: PhoneNumberCapability, phoneNumber) => {
  const { values: configurations } = useConfigurationResource(entityType);

  const { values: communicationQueues } = useResourceValues(communicationQueuesResource);
  const { values: inboxes } = useResourceValues(routingGroupsResource);
  const currentVoiceOrSms = configurations?.find(({ number }) => number === phoneNumber);
  const voiceOrSmsId = currentVoiceOrSms?.id;

  const { inboxName, inboxId } = getInboxForDirectLineVoice(communicationQueues, inboxes, voiceOrSmsId);
  const editPhoneLink = getAgentDesktopURL(`admin/voice/${voiceOrSmsId}`);
  const inboxLink = getAgentDesktopURL(`admin/inboxes/${inboxId}`);

  return { inboxName, editPhoneLink, inboxLink };
};

const getInboxForDirectLineVoice = (communicationQueues, inboxes, voiceOrSmsId) => {
  const communicationQueue = find(communicationQueues, ({ endpointId }) => endpointId === voiceOrSmsId);
  const inboxItem = find(inboxes, ({ id }) => id === communicationQueue?.routingGroupId);

  if (inboxItem) {
    return { inboxName: get(inboxItem, 'name'), inboxId: get(communicationQueue, 'routingGroupId') };
  }

  return { inboxName: '', inboxId: '' };
};

export default useSelectInbox;
